import { __awaiter } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { getHarmonyAppDefinitions } from '@office-start/mos-app-utilities';
import { logError } from '@office-start/telemetry-service';
import { fetchM365AppsConfig } from '../config/fetchM365AppsConfig';
// App definitions retrieved from App Service is serialized and put under domElement with id='m365AppsData'
export const fetchAppDefinitionsFromPage = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const definitionsFromDomElement = yield fetchM365AppsConfig();
        if (definitionsFromDomElement) {
            return getHarmonyAppDefinitions((_a = definitionsFromDomElement.getAcquisitionsResponse) === null || _a === void 0 ? void 0 : _a.acquisitions);
        }
    }
    catch (_b) {
        logError({
            eventName: KnownInstrumentationEvents.M365AppsParseDomConfigError,
            errorType: 'App_Initialization_Error',
            message: 'Failed to parse m365AppsData from DOM',
        });
    }
    return [];
});
//# sourceMappingURL=fetchAppDefinitionsFromPage.js.map